export const contactsData = {
    email: 'leonardo.gutierrez2804@gmail.com',
    phone: '703-675-7049',
    address: 'Fairfax, VA',
    github: 'https://github.com/Leo-Gut28',
    linkedIn: 'https://www.linkedin.com/in/leonardo-gutierrez-ldg21/',
}